<template>
    <div>
        <div id="tianyuan">
            <div class="four_box">
                <div class="item_box" v-for="(item, index) in floorArr" :key="index" :style="{
            backgroundImage: 'url(' + item.back + ')',
            backgroundSize: 'cover',
          }" @click="item.children ? () => {} : toitemPage(item, index)">
                    <div class="position_box"></div>
                    <div class="item_center_box">
                        <div class="en">{{ item.en }}</div>
                        <div class="line"></div>
                        <div class="zh mb">{{ item.zh }}</div>

                        <div v-if="item.children" class="xanr">
                            <div v-for="(i, v) in item.children" class="diaj" :key="v.name">
                                <p class="ziti" @click="item.children ? toitemPage(v, index) : () => {}">
                                    {{ i.name }} <span class="xian"></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getFloorList
    } from "../../http/api";
    export default {
        name: "",
        props: {},
        components: {},
        data() {
            return {
                backimg_flag: -1,
                floorArr: [{
                        en: "FLOOR CHANGER SILICON CRYSTAL FLOORING",
                        zh: "仟领硅晶地板",
                        back: "",
                    },
                    {
                        en: "ANTIBACTERIAL&ANTIVIRAL FLOORING",
                        zh: "抗菌抗病毒地板",
                        back: "",
                    },
                    {
                        en: "INTELLIGENT HEATING FLOORING",
                        zh: "智暖地板",
                        back: "",
                    },
                    {
                        en: "FLAME-RETARDANT AND SMOKE SUPPRESSION FLOORING",
                        zh: "阻燃抑烟地板",
                        back: "",
                    },
                    {
                        en: "HIGH WEAR-RESISTANT FLOORING",
                        zh: "高耐磨地板",
                        back: "",
                    },
                ],
                backimg: "",
            };
        },
        methods: {
            //点击去相应详情
            toitemPage(item, index) {
                if (index == 0) {
                    this.$router.push({
                        path: "/FloorBannerPage",
                        query: {
                            id: index,
                            in: item,
                        },
                    });
                } else {
                    {
                        this.$router.push({
                            path: "/FloorBannerPage",

                            query: {
                                id: index,
                            },
                        });
                    }
                }
            },
            getFloorListfun() {
                getFloorList().then((res) => {
                    if (res.data.length > 0) {
                        console.log(res.data, "a");
                        res.data.map((item, index) => {
                            this.floorArr.map((i, k) => {
                                if (index === k) {
                                    i.back = item.image;
                                    if (item.children.length > 0) {
                                        i.children = [...item.children];
                                    }
                                }
                            });
                        });
                    }
                });
            },
        },
        mounted() {
            this.getFloorListfun();
        },
    };
</script>




<style scoped lang='scss'>
    #tianyuan {
        width: 100vw;
        min-width: 1200px;

        .four_box {
            width: 100%;
            height: 100vh;
            display: flex;
            justify-content: space-between;

            .item_box:hover>.position_box {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background: rgba(26, 26, 26, 0.5);
                transition: all 0.5s;
                z-index: 1;
                cursor: url("../../assets/cursor.png"), none;
            }

            .xian {
                width: 0px;
                height: 1px;
                background-color: rgb(0, 255, 255);
                display: block;
                top: -23px;
                position: absolute;
            }

            .item_box:hover .xanr {
                display: block;
            }

            .xanr {
                position: absolute;
                display: none;
            }

            .ziti:hover>.xian {
                width: 315px;
                transition: all 2s;
            }

            .ziti:hover {
                color: rgb(0, 255, 255);
            }

            .mb {
                margin-bottom: 60px;
            }

            .ziti {
                font-size: 18px;
                color: rgb(255, 255, 255);
                margin-bottom: 32px;
                display: inline-block;
                padding-top: 10px;
            }

            .item_box:hover>.item_center_box>.more {
                color: #ffffff;
                cursor: url("../../assets/cursor.png"), none;
            }

            .item_box {
                // width: 480px;
                width: 25.5%;
                height: 100%;
                border-right: 1px solid #909090;
                display: flex;
                align-items: center;
                padding-left: 20px;
                transition: all 0.5s;
                cursor: url("../../assets/cursor.png"), none;
                position: relative;

                .position_box {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: rgba(0, 0, 0, 1);
                    transition: all 0.5s;
                    z-index: 1;
                }

                .item_center_box {
                    z-index: 2;
                    max-width: 99%;

                    .en {
                        // height: 72px;
                        height: 7.2vh;
                        font-size: 17px;
                        font-family: Arial;
                        font-weight: 400;
                        // line-height: 36px;
                        line-height: 3.6vh;
                        color: #ffffff;
                        letter-spacing: 3px;
                        white-space: pre-wrap;
                        text-overflow: -o-ellipsis-lastline;
               
                        -webkit-box-orient: vertical;
                    }

                    .line {
                        width: 80px;
                        height: 2px;
                        background: #ffffff;
                        // margin: 20px 0;
                        margin: 2vh 0;
                    }

                    .zh {
                        font-size: 30px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        // line-height: 34px;
                        line-height: 3.4vh;
                        color: #ffffff;
                        letter-spacing: 5px;
                        width: 100%;
                    }

                    .more {
                        font-size: 18px;
                        font-family: Arial;
                        font-weight: 400;
                        // line-height: 21px;
                        line-height: 2.1vh;
                        color: rgba(0, 0, 0, 1);
                        letter-spacing: 3px;
                        // margin-top: 20px;
                        margin-top: 2vh;
                        transition: all 0.5s;
                    }
                }
            }
        }

        .four_box>.item_box:last-child {
            border-right: none;
        }
    }
</style>
